'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return typeof window !== 'undefined';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/isBrowser.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/isBrowser.js
 ** module chunks = 0
 **/